{"USE_ANSIBLE_VARS":"true","BUILD_CONFIG":"production","VERSION":"884b73c7b5f5a1da4eb0287bd538510bf1fdefbf"}